import Playback from './Playback';

const resolvePlaybackActions = value => ({
    updatePlayback(nextPlaybackRaw) {
        const nextPlayback = Object.assign(new Playback(), nextPlaybackRaw);
        Object.assign(value, nextPlayback);
    },
    disableFeature() {
        value.isEnabled = false;
    },
});

export default resolvePlaybackActions;
